import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractSpecificDataComponent } from '../../abstract-specific-data.component';

@Component({
    selector: 'app-specific-data-conf2',
    templateUrl: './specific-data-conf2.component.html',
    styleUrls: ['../specific-data-conf.common.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpecificDataConf2Component extends AbstractSpecificDataComponent {
  @Input() override touchNonce?: number;
  override getDataName(): string {
    return 'specific-data-config-2';
  }
}
